import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { RegisterParameterEntryResponseData } from "@opus-dt/shared-types";
import { api } from "@/lib/api-client";

// Registro manual de valor de parâmetro, 1 mutation por campo.
export function useRegisterParameterEntry(machineId: string, lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ parameterId, value }: { parameterId: string; value: string }) =>
      api.post<RegisterParameterEntryResponseData>(
        `/api/v1/machines/${machineId}/parameters/${parameterId}/entries`,
        { value }
      ),
    meta: { skipErrorToast: true },
    onSuccess: () => {
      // ["lines", lineId] cobre por prefixo a key real ["lines", lineId, "machines"]
      // (useLineMachines), que alimenta machine.parameters/currentValue da aba Operação.
      void qc.invalidateQueries({ queryKey: ["parameters", machineId] });
      void qc.invalidateQueries({ queryKey: ["lines", lineId] });
      // Spec 080 — um lançamento em parâmetro de RESTRIÇÃO pode PARAR (ou soltar) a máquina: muda
      // status, abre/fecha evento de parada e mexe no downtime do OEE. O WS já emite a troca de
      // status, mas invalidação por realtime é COMPLEMENTO, não substituto (CLAUDE.md) — quem
      // lançou o valor precisa ver a máquina parada sem depender do socket ter chegado.
      void qc.invalidateQueries({ queryKey: ["machine", machineId] });
      void qc.invalidateQueries({ queryKey: ["machines", lineId] });
      void qc.invalidateQueries({ queryKey: ["events", lineId] });
      void qc.invalidateQueries({ queryKey: ["oee", lineId] });
    },
  });
}
